"use client";
import { useState, useEffect } from "react";
import { ChevronUp } from "lucide-react";

const ScrollUpButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Гүйлгэх үед товчийг харуулах/нуух логик
  const toggleVisibility = () => {
    if (window.scrollY > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Дээш гүйлгэх функц
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  return (
    <div>
      {isVisible && (
        <button
          onClick={scrollToTop}
          className="btn btn-primary position-fixed bottom-0 end-0 m-3 rounded-circle shadow scrollup"
          style={{
            zIndex: 1000,
            width: "45px",
            height: "45px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 0,
          }}
        >
          <ChevronUp size={24} />
        </button>
      )}
    </div>
  );
};

export default ScrollUpButton;
